export type Branch = {
  id: string;
  name: string;
  shortName: string;
  hours: string;
  phone: string;
  whatsapp: string;
  address: string;
  mapsUrl: string;
  wazeUrl: string;
  services: string[];
};

export type Service = {
  id: string;
  title: string;
  category: string;
  summary: string;
  detail: string;
  availability: string;
  preparation: string[];
  branches: string[];
};

export type Doctor = {
  id: string;
  name: string;
  branchId: string;
  credential: string;
  focus: string[];
  role: string;
};

export const primaryDomain = "https://usrahmedic.com";

export const branches: Branch[] = [
  {
    id: "puncak-alam",
    name: "Klinik Usrah Medic 24 Jam Puncak Alam",
    shortName: "Puncak Alam HQ",
    hours: "Setiap hari, 24 jam",
    phone: "011-3566 4998",
    whatsapp: "601135664998",
    address:
      "No. 28 & 28A, Jalan Niaga Bestari 8, Persiaran Puncak Bestari 2, Bandar Puncak Alam, 42300 Kuala Selangor, Selangor",
    mapsUrl: "https://maps.google.com/?q=Klinik+Usrah+Medic+Puncak+Alam",
    wazeUrl: "https://ul.waze.com/ul?q=Klinik%20Usrah%20Medic%20Puncak%20Alam",
    services: ["Rawatan 24 jam", "Ultrasound", "Paediatric", "Kecemasan ringan", "Saringan kesihatan"],
  },
  {
    id: "bukit-jelutong",
    name: "Klinik Usrah Medic Bukit Jelutong",
    shortName: "Bukit Jelutong",
    hours: "Setiap hari, 8:00 pagi - 12:00 tengah malam",
    phone: "012-445 4998",
    whatsapp: "60124454998",
    address: "No.12-G, D'Bayu Business Centre, Jalan Serambi U8/21, Bukit Jelutong, 40150 Shah Alam, Selangor",
    mapsUrl: "https://maps.google.com/?q=Klinik+Usrah+Medic+Bukit+Jelutong",
    wazeUrl: "https://www.waze.com/live-map/directions/my/selangor/shah-alam/klinik-usrah-medic-bukit-jelutong",
    services: ["Rawatan keluarga", "Doktor wanita", "Dermatologi asas", "Paediatric", "Kecemasan ringan"],
  },
  {
    id: "seremban-2",
    name: "Klinik Usrah Medic 24 Jam Seremban 2",
    shortName: "Seremban 2",
    hours: "Setiap hari, 24 jam",
    phone: "011-1130 4998",
    whatsapp: "601111304998",
    address: "No. 109 Ground Floor, Jalan S2 F2, Seksyen F, Seremban 2, 70300 Seremban, Negeri Sembilan",
    mapsUrl: "https://maps.google.com/?q=Klinik+Usrah+Medic+Seremban+2",
    wazeUrl: "https://ul.waze.com/ul?q=Klinik%20Usrah%20Medic%20Seremban%202",
    services: ["Rawatan 24 jam", "Antenatal", "Paediatric", "Primary care", "Saringan kesihatan"],
  },
];

export const services: Service[] = [
  {
    id: "ultrasound",
    title: "Ultrasound 2D/3D/4D/5D",
    category: "Wanita & Kehamilan",
    summary: "Semak slot ultrasound dan dapatkan panduan ringkas sebelum hadir.",
    detail:
      "Sesuai untuk ibu mengandung yang ingin membuat pemeriksaan berkala, semakan perkembangan bayi, atau mendapatkan nasihat lanjut daripada doktor mengikut jadual cawangan.",
    availability: "Temujanji disarankan supaya masa menunggu lebih terkawal.",
    preparation: ["Bawa buku pink atau rekod pemeriksaan berkaitan", "Maklumkan usia kandungan", "Sahkan slot melalui WhatsApp jika hadir pada waktu puncak"],
    branches: ["puncak-alam", "seremban-2"],
  },
  {
    id: "rawatan-am",
    title: "Rawatan dewasa & kanak-kanak",
    category: "Keluarga",
    summary: "Rawatan harian untuk demam, batuk, sakit tekak, gastrik, luka ringan dan aduan biasa.",
    detail: "Pasukan klinik membantu membuat penilaian awal, rawatan asas, ubat, rujukan dan susulan mengikut keperluan pesakit.",
    availability: "Walk-in diterima. Untuk kes kecemasan serius, hubungi 999 atau terus ke hospital.",
    preparation: ["Bawa senarai ubat semasa", "Maklumkan alahan ubat", "Bawa rekod klinik atau hospital jika ada"],
    branches: ["puncak-alam", "bukit-jelutong", "seremban-2"],
  },
  {
    id: "paediatric",
    title: "Rawatan susulan kanak-kanak & vaksinasi bayi",
    category: "Kanak-kanak",
    summary: "Pemeriksaan susulan, demam, batuk, tumbesaran dan vaksinasi mengikut kesesuaian.",
    detail: "Fokus kepada komunikasi jelas dengan ibu bapa, pemeriksaan yang tenang, dan nasihat penjagaan di rumah.",
    availability: "Walk-in diterima; vaksinasi dan susulan tertentu lebih baik ditempah.",
    preparation: ["Bawa buku imunisasi", "Maklumkan berat anak terkini jika diketahui", "Nyatakan tempoh gejala dan ubat yang sudah diberi"],
    branches: ["puncak-alam", "bukit-jelutong", "seremban-2"],
  },
  {
    id: "saringan-kesihatan",
    title: "Pakej saringan kesihatan",
    category: "Saringan",
    summary: "Pemeriksaan darah, tekanan darah, ECG dan pakej tertentu termasuk saringan bakal haji.",
    detail: "Direka untuk pesakit yang mahu semakan kesihatan berkala, persediaan ibadah, atau pemantauan risiko penyakit kronik.",
    availability: "Sila semak slot dan keperluan puasa melalui WhatsApp.",
    preparation: ["Tanya sama ada perlu berpuasa", "Bawa kad pengenalan", "Bawa rekod keputusan lama jika ada"],
    branches: ["puncak-alam", "seremban-2"],
  },
  {
    id: "kecemasan-ringan",
    title: "Rawatan kecemasan ringan & kemalangan",
    category: "Urgent care",
    summary: "Penilaian awal untuk luka, kecederaan ringan, nebuliser, jahitan dan dressing.",
    detail: "Klinik boleh membantu kes ringan yang sesuai di peringkat klinik. Kes berat atau mengancam nyawa perlu ke Jabatan Kecemasan hospital.",
    availability: "Walk-in diterima mengikut keadaan klinik.",
    preparation: ["Datang segera untuk luka berdarah", "Maklumkan punca kecederaan", "Bawa rekod tetanus jika berkaitan"],
    branches: ["puncak-alam", "bukit-jelutong", "seremban-2"],
  },
  {
    id: "wanita",
    title: "Kesihatan wanita, Pap smear & perancang keluarga",
    category: "Wanita & Kehamilan",
    summary: "Pap smear, perancang keluarga, antenatal, postnatal dan konsultasi kesihatan wanita.",
    detail: "Usrah Medic menekankan suasana selesa untuk wanita dan keluarga, dengan doktor wanita tersedia mengikut jadual cawangan.",
    availability: "Temujanji disarankan untuk semak jadual doktor wanita.",
    preparation: ["Nyatakan tujuan pemeriksaan", "Semak jadual doktor wanita", "Bawa rekod pemeriksaan berkaitan"],
    branches: ["puncak-alam", "bukit-jelutong", "seremban-2"],
  },
];

export const doctors: Doctor[] = [
  {
    id: "nurul-adilah",
    name: "Dr. Nurul 'Adilah Binti Shuhardi",
    branchId: "puncak-alam",
    credential: "MBBCh (Mansoura University)",
    focus: ["Paediatric", "NCD", "Surgery", "Emergency"],
    role: "Clinical Doctor / Director",
  },
  {
    id: "nur-as-syuhada",
    name: "Dr. Nur As-Syuhada Binti Amran",
    branchId: "puncak-alam",
    credential: "MBBCh (Ain Shams University)",
    focus: ["Paediatric", "Obstetrics", "Gynecology"],
    role: "Resident Doctor",
  },
  {
    id: "sirin-fathima",
    name: "Dr. Sirin Fathima Madina Binti Mohamed",
    branchId: "puncak-alam",
    credential: "MBBS (MAHSA University)",
    focus: ["Antenatal", "Paediatric", "Primary Care", "Obstetric"],
    role: "Resident Doctor",
  },
  {
    id: "nor-adibah",
    name: "Dr. Nor Adibah Aminah Binti Mohd Amin",
    branchId: "seremban-2",
    credential: "MBBCh (Alexandria University)",
    focus: ["Antenatal Care", "Paediatrics", "Surgery"],
    role: "Resident Doctor",
  },
  {
    id: "umie-nadiah",
    name: "Dr. Umie Nadiah Binti Shalahuddin",
    branchId: "bukit-jelutong",
    credential: "MBBCh (Zagazig University)",
    focus: ["Dermatology", "Family Medicine", "Psychiatry"],
    role: "Resident Doctor",
  },
  {
    id: "nurelysha",
    name: "Dr. Nurelysha Istishad Binti Badely",
    branchId: "bukit-jelutong",
    credential: "MB, BCh, BAO (Ireland)",
    focus: ["Paediatrics", "Emergency Medicine"],
    role: "Resident Doctor",
  },
];

export const promotions = [
  {
    title: "Saringan Kesihatan Bakal Haji",
    summary: "Pakej pemeriksaan untuk persediaan ibadah. Semak syarat dan slot melalui WhatsApp.",
    serviceId: "saringan-kesihatan",
  },
  {
    title: "Kempen Vaksin Haji & Umrah",
    summary: "Semak ketersediaan vaksin, dokumen yang diperlukan dan masa terbaik untuk hadir.",
    serviceId: "saringan-kesihatan",
  },
  {
    title: "Pakej Ansuran Implanon",
    summary: "Sesuai untuk konsultasi perancang keluarga. Temujanji disarankan.",
    serviceId: "wanita",
  },
];

export const faqs = [
  {
    question: "Adakah semua cawangan 24 jam?",
    answer: "Puncak Alam HQ dan Seremban 2 disenaraikan 24 jam. Bukit Jelutong beroperasi setiap hari 8:00 pagi hingga 12:00 tengah malam.",
  },
  {
    question: "Adakah ini booking slot yang disahkan?",
    answer: "Versi pertama ini ialah permintaan slot pilihan. Staf klinik akan mengesahkan slot melalui panggilan atau WhatsApp.",
  },
  {
    question: "Boleh walk-in tanpa temujanji?",
    answer: "Rawatan biasa menerima walk-in. Untuk ultrasound, vaksin tertentu atau pemeriksaan yang perlukan persediaan, semak slot dahulu.",
  },
  {
    question: "Bagaimana jika saya tidak pasti servis mana yang sesuai?",
    answer: "Pilih cawangan terdekat dan gunakan WhatsApp. Mesej akan dipraisi dengan konteks supaya staf boleh bantu tapis keperluan anda.",
  },
];
